/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataSourceTypeDefinitionDto } from '../../models/data-source-type-definition-dto';

export interface DatasourceTypesTypeDefinitionIdGet$Json$Params {
  typeDefinitionId: string;
}

export function datasourceTypesTypeDefinitionIdGet$Json(http: HttpClient, rootUrl: string, params: DatasourceTypesTypeDefinitionIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DataSourceTypeDefinitionDto>> {
  const rb = new RequestBuilder(rootUrl, datasourceTypesTypeDefinitionIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('typeDefinitionId', params.typeDefinitionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataSourceTypeDefinitionDto>;
    })
  );
}

datasourceTypesTypeDefinitionIdGet$Json.PATH = '/datasource-types/{typeDefinitionId}';
